import { types, flow } from "mobx-state-tree";
import CONSTANTS from "const/constants";

import { UserCredentialBaseStore } from "./user-credential-base-store";

const { CREDENTIAL_TYPES, CREDENTIAL_TYPE_LABELS, PLATFORM_TYPES } = CONSTANTS;

const model = {
    facebookName: types.maybeNull(types.string),
    facebookPageName: types.maybeNull(types.string),
    facebookProfileImageUrl: types.maybeNull(types.string),
    facebookPageProfileImageUrl: types.maybeNull(types.string),
    credentialType: CREDENTIAL_TYPES.FACEBOOK
};

const volatile = (self) => {
    const __name__ = self.name;
    const __profileImage__ = self.profileImage;

    return {
        name: self?.facebookPageName ?? self?.facebookName ?? __name__,
        profileImage:
            self?.facebookPageProfileImageUrl ??
            self?.facebookProfileImageUrl ??
            __profileImage__,
        facebookCrosspostPageIds: [],
        type: `facebook`,
        typeLabel: CREDENTIAL_TYPE_LABELS.FACEBOOK,
        platformType: PLATFORM_TYPES.FACEBOOK,
        shareKey: `shareViaFacebookCount`
    };
};

const views = (self) => {
    return {
        getFacebookCrosspostingPages() {
            return {
                facebookCrosspostPageIds: self.facebookCrosspostPageIds
            };
        }
    };
};

const viewOverrides = (self) => {
    return {
        isSocialMedia() {
            return true;
        }
    };
};

const actions = (self) => {
    const __onShareSuccessful__ = self.onShareSuccessful;

    return {
        onShareSuccessful(response) {
            return __onShareSuccessful__.call(self, self.shareKey, response);
        },

        setFacebookCrosspostingPages(pageIds) {
            self.facebookCrosspostPageIds = pageIds;
        },

        addFacebookCrosspostingPage(pageId) {
            if (!self.facebookCrosspostPageIds.includes(pageId)) {
                self.facebookCrosspostPageIds.push(pageId);
            }
        }
    };
};

const asyncActions = (self) => {
    const __share__ = self.share;

    return {
        /**
         * Overrides the base share method to add facebook specific share data
         * @async
         * @param {String} shareId
         * @param {object} data
         * @return {ShareObject | Error}
         */
        share: flow(function* share(shareId, data) {
            return yield __share__.call(self, shareId, {
                ...data,
                ...self.getFacebookCrosspostingPages()
            });
        })
    };
};

const _UserCredentialFacebookStore = types
    .model(`UserCredentialFacebook`, model)
    .volatile(volatile)
    .views(views)
    .views(viewOverrides)
    .actions(actions)
    .actions(asyncActions);

export const UserCredentialFacebookStore = types
    .compose(UserCredentialBaseStore, _UserCredentialFacebookStore)
    .named(`UserCredentialFacebookStore`);
